import { gsap } from 'gsap'

export class Concept {
  constructor() {
    this.inner = document.querySelector('.p-index_concept__inner')
    this.sections = gsap.utils.toArray('.p-index_concept__section')
    if (!this.inner || !this.sections.length) return
    this._init()
  }

  _init() {
    const innerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          innerObserver.disconnect()
          this._runSequence()
        })
      },
      { threshold: 0.2 },
    )
    innerObserver.observe(this.inner)
  }

  _runSequence() {
    const sections = this.sections
    const copyStagger = 0.6
    const copyDelay = 0.3

    ;['.copy01', '.copy02', '.copy03'].forEach((cls, i) => {
      const targets = document.querySelectorAll(`.p-index_concept__copy__text${cls}`)
      gsap.fromTo(
        targets,
        { opacity: 0, y: 24 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: 'back.out(1.6)',
          delay: copyDelay + i * copyStagger,
        },
      )
    })

    sections.forEach((section, i) => {
      const sectionDelay = copyDelay + i * copyStagger

      const image = section.querySelector('.p-index_concept__section__image')
      image.classList.add('is-act')
      gsap.to(image, {
        opacity: 1,
        duration: 0.5,
        ease: 'power2.out',
        delay: sectionDelay,
      })

      this._activateDecorations(section, sectionDelay)

      const texts = section.querySelectorAll('.p-index_concept__section__text')
      gsap.fromTo(
        texts,
        { opacity: 0, y: 16 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          ease: 'back.out(1.6)',
          delay: sectionDelay,
        },
      )
    })

    const detailSpans = document.querySelectorAll('.p-index_concept__detail ')
    if (detailSpans.length) {
      const finalDelay = copyDelay + (sections.length - 1) * copyStagger + 0.5
      gsap.fromTo(
        detailSpans,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'back.out(1.6)',
          delay: finalDelay,
          stagger: 0.2,
        },
      )
    }
  }

  _activateDecorations(section, sectionDelay = 0) {
    section.querySelectorAll('[class*="line-"]').forEach((el) => el.classList.add('is-act'))
    const inks = [...section.querySelectorAll('[class*="ink-"]')]
    if (!inks.length) return
    gsap.fromTo(
      inks,
      { opacity: 0, scale: 0 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.2,
        stagger: 0.04,
        ease: 'cubic-bezier(0.1, 1, 0.1, 1)',
        delay: sectionDelay,
      },
    )
  }
}
